module.exports = __webpack_public_path__ + "static/hero-drones-ind-79de7f7eb371c6e03d9b55e585f1a083.png";